import ValidatorResult from "../classes/validator.results";
export default class RegExpValidationRule {
    name = 'regexp';
    validate(validation, rule, value, object, manager) {
        //Message
        let tMessage = '';
        let tExpression = '';
        //Set
        if (rule.props?.expression) {
            tExpression = rule.props?.expression;
        }
        else {
            tExpression = rule.props;
        }
        if (rule.props?.message) {
            tMessage = rule.props?.message;
        }
        else {
            tMessage = appHost.localizer?.t('system.Validation.Regexp', [validation.displayName]) ?? '';
        }
        //Expression
        let tRegExp = new RegExp(tExpression);
        //Rule
        if (value === undefined || value === null) {
            return new ValidatorResult(true);
        }
        if (tRegExp.test(value) === false) {
            return new ValidatorResult(false, tMessage);
        }
        return new ValidatorResult(true);
    }
}
